module.exports = __webpack_public_path__ + "img/Bangladesh.67d3790b.svg";